import React from 'react';
import {
  normalizeSkillsList,
  parseProfessionalLinksFromUser,
} from '../../utils/publicProfileDisplay';

function linkLabel(url: string): string {
  try {
    const host = new URL(url.startsWith('http') ? url : `https://${url}`).hostname;
    return host.replace(/^www\./, '');
  } catch {
    return url.length > 36 ? `${url.slice(0, 36)}…` : url;
  }
}

interface PublicProfileSidebarExtrasProps {
  userData: Record<string, unknown> | null | undefined;
  onResumePreview?: () => void;
  showResume?: boolean;
}

const PublicProfileSidebarExtras: React.FC<PublicProfileSidebarExtrasProps> = ({ userData }) => {
  const skills = normalizeSkillsList(userData?.skills);
  const professionalLinks = parseProfessionalLinksFromUser(userData);

  return (
    <div className="public-profile-sidebar-extras">
      <div className="public-profile-sidebar-card">
        <h3 className="public-profile-sidebar-card__title">Skills</h3>
        {skills.length ? (
          <div className="public-profile-skills-list">
            {skills.map((skill) => (
              <span key={skill} className="public-profile-skill-chip">
                {skill}
              </span>
            ))}
          </div>
        ) : (
          <p className="public-profile-sidebar-empty mb-0">No skills listed yet.</p>
        )}
      </div>

      <div className="public-profile-sidebar-card">
        <h3 className="public-profile-sidebar-card__title">Professional Links</h3>
        {professionalLinks.length ? (
          <div className="public-profile-links-list">
            {professionalLinks.map((link) => (
              <a
                key={link}
                href={link.startsWith('http') ? link : `https://${link}`}
                target="_blank"
                rel="noopener noreferrer"
                className="public-profile-link-row"
              >
                <span>{linkLabel(link)}</span>
                <span aria-hidden="true">↗</span>
              </a>
            ))}
          </div>
        ) : (
          <p className="public-profile-sidebar-empty mb-0">No professional links added yet.</p>
        )}
      </div>
    </div>
  );
};

export default PublicProfileSidebarExtras;
